import { Pipe, PipeTransform } from '@angular/core';

const HAS_SCHEME_REGEX = /^([a-z][a-z0-9+.-]*:|\/\/)/i;

@Pipe({
  name: 'externalUrl',
})
export class ExternalUrlPipe implements PipeTransform {
  transform(url?: string | null): string {
    const value = url?.trim();

    if (!value) {
      return '';
    }

    return HAS_SCHEME_REGEX.test(value) ? value : `https://${value}`;
  }
}
